export enum LoginProviderTypeId {
  AzureAd = 1,
  NETS = 2,
  Oidc = 3,
}
